import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Intro } from "../components/Intro";
import { Villas } from "../components/Villas";
import { Moments } from "../components/Moments";
import { Marquee } from "../components/Marquee";
import { WhyDune } from "../components/WhyDune";
import { Gallery } from "../components/Gallery";
import { Celebrations } from "../components/Celebrations";
import { Faqs, FAQS } from "../components/Faqs";
import { DuneJournal } from "../components/DuneJournal";
import { Enquiry } from "../components/Enquiry";
import { LocationSection } from "../components/LocationSection";
import { Footer } from "../components/Footer";
import { useSeo } from "../hooks/useSeo";
import { ORGANIZATION, DUNE_LODGING, faqSchema, breadcrumbs, graph } from "../seo/schema";

export default function DunePage() {
  useSeo({
    title: "Dune Villas at Area 83 | Private Pool Villas Near Bengaluru | erth. escapes",
    description:
      "Dune Villas at Area 83: two private six-bedroom villas near Bengaluru, each with a pool, sleeping 12+2 guests, breakfast and dinner included. From ₹60,000 per villa per night. Off Bannerghatta Road.",
    path: "/dune-villas",
    image: "/images/exterior-hero.webp",
    jsonLd: graph(
      ORGANIZATION,
      DUNE_LODGING,
      breadcrumbs([{ name: "erth. escapes", path: "/" }, { name: "Dune Villas at Area 83", path: "/dune-villas" }]),
      faqSchema(FAQS)
    ),
  });

  return (
    <div data-testid="dune-page" className="min-h-screen bg-brand-ivory">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <Villas />
        <Moments />
        <Marquee />
        <WhyDune />
        <Gallery />
        <Celebrations />
        <Faqs />
        <DuneJournal />
        <Enquiry />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}
